import { GameServices } from "game/GameServices";
import { View } from "@westpierstudio/luma/mvc";
import { MultiplierBadge } from "./MultiplierBadge";
import { ReelsLayout } from "components/reels/ReelsModel";

export class OverlayMultiplierBadges extends View {
    multiplierBadges: MultiplierBadge[] = [];

    constructor(protected override readonly services: GameServices) {
        super(services);
    }

    setup(layout: ReelsLayout): void {

        this.services.factory.applySpec(this, {x: layout.x, y: layout.y});

        const {symbolCount, symbolSize} = layout;
        let badge;

        for (let i=0; i<symbolCount; i++) {

            badge = new MultiplierBadge(this.services);
            badge.y = (i + 1) * symbolSize.height;

            this.addChild(badge);
            this.multiplierBadges.push(badge);
        }
    }

    startWinAnims(winningBadgeData: {index: number, value: number}[]): void {

        let badge;

        for (const winData of winningBadgeData) {

            badge = this.multiplierBadges[winData.index];

            badge.setValue(winData.value);
            badge.visible = true;
            badge.startWinAnimLoop();
        }
    }

    stopWinAnims(): void {
        this.reset();
    }

    override reset(): void {

        for (const badge of this.multiplierBadges) {
            badge.reset();
        }
    }
}